import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as Logo } from '../../assets/logo/zecado.svg';

/**
 * The reduced header shown during checkout, in place of the full Navbar.
 *
 * Checkout is a funnel the customer has already committed to, so SHOP / ABOUT / CONTACT / search
 * only offer ways out of it. What they do still need is a way back to the cart to change a
 * quantity - the checkout page itself provides none, so dropping the navbar entirely would leave
 * browser-back as the only route and cost more abandonment than the nav links do.
 *
 * Static rather than fixed: the page below scrolls past it normally, which avoids the overlap the
 * fixed Navbar caused on pages that centre their own content.
 */
const CheckoutHeader = () => (
  <header className="border-b border-black/10 bg-white">
    <div className="max-w-[1440px] mx-auto px-4 md:px-8 lg:px-12 h-20 flex items-center justify-between gap-4">
      {/* Sized to match the "Secure checkout" note so the logo stays optically centred. */}
      <Link
        to="/cart"
        className="flex items-center gap-2 text-xs tracking-[0.15em] uppercase font-light text-black/60 hover:text-black transition-colors shrink-0 sm:w-40"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 19l-7-7 7-7" />
        </svg>
        <span className="hidden sm:inline">Back to cart</span>
      </Link>

      <Link to="/" aria-label="Zecado home">
        <Logo className="h-6 text-black fill-black" />
      </Link>

      <span className="hidden sm:flex items-center justify-end gap-2 text-[10px] tracking-[0.15em] uppercase font-light text-black/40 w-40">
        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
        Secure checkout
      </span>

      {/* Keeps the logo centred on phones, where the lock note is hidden. */}
      <span className="sm:hidden w-4" aria-hidden="true" />
    </div>
  </header>
);

export default CheckoutHeader;
